export const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];
export const CATEGORY_CHOICES = [
  'Service Revenue',
  'Product Sales', 
  'Interest Income',
  'Other',
];

export const STATUS_CHOICES = [
  'Pending',
  'Received',
  'Cancelled',
];

export const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'category', label: 'Category', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'currency', label: 'Currency', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'remarks', label: 'Remarks', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];

export const getInitialIncomeFormData = () => ({
  name: '',
  amount: '',
  category: '',
  currency: 'PKR',
  date: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD format
  status: 'Received',
  remarks: '',
  money_account: '',
});

export const getIncomeFormDataFromRecord = (income) => ({
  name: income.name || '',
  amount: income.amount?.toString() || '',
  category: income.category || '',
  currency: income.currency || 'PKR',
  date: income.date || '',
  status: income.status || 'Received',
  remarks: income.remarks || '',
  money_account: income.money_account || '',
});

export const formatIncomeDataForSubmission = (formData) => ({
  name: formData.name.trim(),
  amount: parseFloat(formData.amount) || 0,
  category: formData.category,
  currency: formData.currency,
  date: formData.date,
  status: formData.status,
  remarks: formData.remarks.trim(),
  money_account: formData.money_account || null,
});